<template>
  <div class="card card-custom gutter-b" style="margin-top: 20px;">
    <!--begin::Header-->
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Log de Acesso
        </span>
        <span class="text-muted mt-3 font-weight-bold font-size-sm">
          Acompanhe quais usuários estão acessando o sistema
        </span>
      </h3>
      <div class="card-toolbar"></div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div
      class="card-body pt-2 pb-0"
      style="max-height: 418px; overflow-y: auto; overflow-x: auto;"
    >
      <!--begin::Table-->
      <div class="table-responsive" style="overflow-x: initial;">
        <table class="table table-borderless table-vertical-center">
          <thead>
            <tr>
              <th class="p-0" style="width: 50px"></th>
              <th class="p-0" style="min-width: 150px"></th>
              <th class="p-0" style="min-width: 120px"></th>
              <th class="p-0" style="min-width: 70px"></th>
              <th class="p-0" style="min-width: 70px"></th>
              <th class="p-0" style="min-width: 50px"></th>
            </tr>
          </thead>
          <tbody v-if="logs.length">
            <template v-for="(item, i) in logs.slice(0, quantidadeExibir)">
              <tr v-bind:key="i">
                <td class="pl-0">
                  <div class="symbol symbol-50 symbol-light mr-2 mt-2">
                    <span class="symbol-label">
                      <img
                        :src="
                          fgModoPR == 'R'
                            ? 'media/svg/avatars/001-boy.svg'
                            : 'media/svg/avatars/007-boy-2.svg'
                        "
                        class="h-75 align-self-end"
                        alt=""
                      />
                    </span>
                  </div>
                </td>
                <td class="pl-0">
                  <a
                    href="javascript:;"
                    @click="selecionarLog(item)"
                    class="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg"
                    :class="{
                      receber: fgModoPR == 'R',
                      pagar: fgModoPR == 'P'
                    }"
                  >
                    {{ item.EMAIL }}
                  </a>
                  <span class="text-muted font-weight-bold d-block">
                    {{ item.USUARIO ? item.USUARIO : "Sem usuário associado" }}
                  </span>
                </td>
                <td></td>
                <td class="text-right">
                  <span
                    class="text-muted font-weight-bold d-block font-size-sm"
                  >
                    {{ retornaStatus(item) }}
                  </span>
                  <span
                    class="text-dark-75 font-weight-bolder d-block font-size-lg"
                  ></span>
                </td>
                <td class="text-right">
                  <span
                    class="text-muted font-weight-bold d-block font-size-sm"
                  >
                    Data/Hora
                  </span>
                  <span
                    class="font-weight-bolder text-primary"
                    :class="{
                      receber: fgModoPR == 'R',
                      pagar: fgModoPR == 'P'
                    }"
                  >
                    {{ formataData(item.DATA_INCLUSAO) }}
                  </span>
                </td>
                <td class="text-right pr-0">
                  <a
                    href="javascript:;"
                    @click="selecionarLog(item)"
                    class="btn btn-icon btn-light btn-sm"
                  >
                    <span class="svg-icon svg-icon-md svg-icon-success">
                      <!--begin::Svg Icon | path:assets/media/svg/icons/Navigation/Arrow-right.svg-->
                      <inline-svg
                        src="media/svg/icons/Navigation/Arrow-right.svg"
                      />
                      <!--end::Svg Icon-->
                    </span>
                  </a>
                </td>
              </tr>
            </template>
            <template v-if="quantidadeExibir < quantidadeMaxima">
              <tr>
                <td colspan="6">
                  <a
                    href="javascript:;"
                    @click="exibirMais"
                    class="btn btn-block btn-sm btn-primary font-weight-bolder text-uppercase"
                    :class="{
                      receber: fgModoPR == 'R',
                      pagar: fgModoPR == 'P'
                    }"
                  >
                    Mostrar mais
                  </a>
                </td>
              </tr>
            </template>
          </tbody>
          <tbody v-if="!logs.length">
            <tr>
              <td class="pl-0">
                <div class="symbol symbol-50 symbol-light mr-2 mt-2">
                  <span class="symbol-label">
                    <img
                      :src="
                        fgModoPR == 'R'
                          ? 'media/svg/avatars/001-boy.svg'
                          : 'media/svg/avatars/007-boy-2.svg'
                      "
                      class="h-75 align-self-end"
                      alt=""
                    />
                  </span>
                </div>
              </td>
              <td class="pl-0">
                <a
                  href="javascript:;"
                  class="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg"
                >
                  Sem logs de acesso
                </a>
                <span class="text-muted font-weight-bold d-block">
                  ----
                </span>
              </td>
              <td></td>
              <td class="text-right">
                <span class="text-muted font-weight-bold d-block font-size-sm">
                </span>
                <span
                  class="text-dark-75 font-weight-bolder d-block font-size-lg"
                >
                </span>
              </td>
              <td class="text-right">
                <span class="font-weight-bolder text-primary"> </span>
              </td>
              <td class="text-right pr-0"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--end::Table-->
    </div>
    <!--end::Body-->
  </div>
</template>

<style lang="scss" scoped></style>

<script>
import { mapGetters, mapActions } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import moment from "moment";

export default {
  name: "LogAcesso",
  data() {
    return {
      logs: [],
      quantidadeExibir: 10,
      quantidadeMaxima: 0
    };
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Log de Acesso" }]);

    let resultado = await this.getLogsAcesso({
      quantidade: 0,
      quantidadeExibir: 10
    });

    this.logs = resultado.dados;
    this.quantidadeMaxima = resultado.quantidadeTotal;
  },
  computed: {
    ...mapGetters(["fgModoPR"])
  },
  methods: {
    ...mapActions(["getLogsAcesso"]),
    formataData(data) {
      return moment(data, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");
    },
    async exibirMais() {
      let vm = this;

      this.quantidadeExibir += 10;

      let resultado = await this.getLogsAcesso({
        quantidade: this.quantidadeExibir - 10,
        quantidadeExibir: this.quantidadeExibir
      });

      this.quantidadeMaxima = resultado.quantidadeTotal;

      if (resultado.dados.length) {
        resultado.dados.forEach(function(item) {
          vm.logs.push(item);
        });
      }
    },
    selecionarLog() {},
    retornaStatus(item) {
      if (item.RESULTADO == "1") {
        return "Sucesso";
      } else {
        return "Falhou";
      }
    }
  }
};
</script>
